import { useState } from "react";
import { subscriptionService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";

const getTradeListUUID = createUUID();

const deleteTradeUUID = createUUID();
const createTradeUUID = createUUID();

export const useManageTradeViewModel = () => {
  const [tradeList, setTradeList] = useState([]);
  const stateManager = useComponentState();

  const getTradeList = async () => {
    stateManager.abort(getTradeListUUID);
    return stateManager.run(async () => {
      const response = await subscriptionService.trades.getAll({
        sort: "name asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setTradeList(response.data);
        return response.data;
      }
      return null;
    }, getTradeListUUID);
  };

  const updateTrade = async (id, data) => {
    stateManager.abort(deleteTradeUUID);
    return stateManager.run(async () => {
      const response = await subscriptionService.trades.update({
        id,
        data,
        toastMessageConfig: {
          success: { text: "Trade updated successfully!" },
          failure: { text: "Failed to update trade!" },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        return response.data;
      }
      return null;
    }, deleteTradeUUID);
  };

  const deleteTrade = async (id, data) => {
    stateManager.abort(deleteTradeUUID);
    return stateManager.run(async () => {
      const response = await subscriptionService.trades.delete({
        id,
        data,
        toastMessageConfig: {
          success: { text: "Trade deleted successfully!" },
          failure: { text: "Failed to delete trade!" },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        return response;
      }
      return null;
    }, deleteTradeUUID);
  };

  const createTrade = (data) => {
    stateManager.abort(createTradeUUID);
    return stateManager.run(async () => {
      const response = await subscriptionService.trades.create({
        data,
        toastMessageConfig: {
          success: { text: "Trade was created successfully." },
          failure: { text: "Failed to create trade." },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        return response.data;
      }
      return null;
    }, createTradeUUID);
  };

  return {
    tradeList,
    loading: stateManager.isBusy(),
    getTradeList,
    updateTrade,
    deleteTrade,
    createTrade,
  };
};
